<template>
  <div class="top-page layout-p pr-0">
    <logo class-name="top-page__logo" />
    <div class="top-page__title font-weight-bold font-80">
      <span>A radically better</span>
      <div>
        <span class="top-page__title-highlight">investment</span>
        fund
      </div>
    </div>

    <div class="top-page__content">
      <div class="top-page__explanation font-20 mt-80">
        VBank is a leader in wholesale financial services.
        <br>
        We help our clients meet the demands of changing markets.
      </div>

      <div class="top-page__img">
        <b-img
          class="w-100"
          :src="people"
          alt=""
        />
      </div>
      <btn-group class="top-page__btn-group" />
    </div>
  </div>
</template>

<script>
  import people from '~/assets/img/people.svg'
  import BtnGroup from '../BtnGroup';
  import Logo from '../Logo';

  export default {
    name: 'TopPage',
    components: {
      BtnGroup,
      Logo,
    },
    data() {
      return { people }
    }
  }
</script>

<style lang="scss" src="./TopPage.scss" />
